import { Injectable } from '@angular/core';
import { CATALOG_CODE, CatalogCodeType } from '../../../../../shared/constants/catalog-codes';
import { AbstractCatalogOptionLoader } from './catalog-option-loader.service';

@Injectable()
export class SpacingOptionLoader extends AbstractCatalogOptionLoader {
  getCatalogType(): CatalogCodeType {
    return CATALOG_CODE.TIME_PER_LOAD;
  }
}
